import $ from 'jquery'
import 'slick-carousel/slick/slick'
import 'slick-carousel/slick/slick.css'
import Base from 'luminate/src/modules/base'
import {frame} from '../utilities'

export default Base.extend({
	directive: 'slick',

	events: {

		init: function()
		{
			const $element = $(this.$element)

			$element.slick(this.$settings)

			const playVideos = function()
			{
				$element.find('.slick-slide.slick-active video[autoplay]').each(function()
				{
					this.play()
				})
			}

			const pauseVideos = function()
			{
				$element.find('.slick-slide:not(.slick-active) video[autoplay]').each(function()
				{
					this.pause()
				})
			}

			$element.on('beforeChange', e => setTimeout(playVideos, 10))
			$element.on('afterChange', pauseVideos)

			playVideos()

			if($element.hasClass('slideshow') && $element.hasClass('-fit-image'))
			{
				const getHeight = () =>
				{
					let maxHeight = 0

					$element.find('.slideshow_slide_content').each(function()
					{
						const $this = $(this)
						const paddingTop = parseFloat($this.css('padding-top').replace('px', ''))
						const paddingBottom = parseFloat($this.css('padding-bottom').replace('px', ''))
						const innerHeight = $this.children().height()

						maxHeight = Math.max(maxHeight, innerHeight + paddingTop + paddingBottom)
					})

					return maxHeight
				}

				const setHeight = () =>
				{
					const minHeight = getHeight()

					$element.find('.slideshow_slide_background')
						.css('min-height', minHeight + 'px')

					$element.find('.slideshow_slide_background .media').each(function()
					{
						const $this = $(this)
						const height = $this.height()

						$this.css('transform', height < minHeight ? `scale(${minHeight / height})` : '')
					})
				}

				$(window).on('resize', e => frame(setHeight))

				$element.on('beforeChange', e => setTimeout(setHeight, 10))
				$element.on('afterChange', setHeight)

				setHeight()
			}
		}
	}
})



/** WEBPACK FOOTER **
 ** ./source/scripts/modules/slick.js
 **/